import {convertCurrency} from "@fast-simon/currency-converter";
import {get} from "svelte/store";
import type {Currency, Platform} from "@fast-simon/types";
import {currentCurrencyRate} from "./getBCCurrentCurrency";
import {BCCurrenciesRates, BCSiteCurrency, platform} from "../store/store";

export function convertPrice(platform: Platform, price: number, current: Currency) {
    if(platform === 'Shopify') {
        return convertCurrency(platform, Number(price), current);
    } else if(platform === 'BigCommerce') {
        const exchangeRate =  get(BCSiteCurrency)? currentCurrencyRate(current, get(BCSiteCurrency), get(BCCurrenciesRates)):1
        if(exchangeRate) {
            if(Number(exchangeRate) !== 1) {
                return {price: Math.round(Number(exchangeRate) * price * 100) / 100, currency: current}
            }
        }
    }
    return {price, currency: current};
}